module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pn-b3fc2087af0c8423bfacd3aaccc799f8.svg";